<template>
  <div>
    <BButton
      v-if="event.available_reg_type == 'rsvp' && !event.reg_status"
      size="md"
      variant="outline-dark"
      class="w-100"
      @click="register"
    >
      {{ t('RSVP') }}
    </BButton>

    <BButton
      v-if="event.available_reg_type == 'waiting_list' && !event.reg_status"
      variant="outline-dark"
      class="w-100"
      @click="register"
    >
      {{ t('Waiting list') }}
    </BButton>

    <BButton v-if="event.reg_status" variant="outline-warning" class="w-100" @click="unregister">
      <span v-if="event.reg_status.type == 0">{{ t('Withdraw') }}</span>
      <span v-if="event.reg_status.type == 1">
        {{ t('Leave waiting list') }}
      </span>
    </BButton>
    <BButton
      v-if="event.available_reg_type == 'invitations_only'"
      variant="outline-dark"
      class="w-100"
      disabled
    >
      {{ t('Invitations only') }}
    </BButton>
  </div>
</template>

<script setup lang="ts">
import { useToastController } from 'bootstrap-vue-next'
import { useI18n } from 'vue-i18n'
import { useNuxtApp } from '#imports'

interface RegStatus {
  type: number
}

export interface EventReg {
  id: number
  title?: string
  available_reg_type?: string
  reg_status?: RegStatus | null
}

interface RegisterResponse {
  status: string
  registration?: { type: number }
  message?: string
}

const props = defineProps<{
  event: EventReg
}>()

const emit = defineEmits<{
  reg_action: [payload: { response: RegisterResponse; action_type: string | null }]
}>()

const { t, locale } = useI18n({
  useScope: 'local',
  messages: {
    en: {
      Withdraw: 'Withdraw',
      'Invitations only': 'Invitations only',
      'You have successfully registered for': 'You have successfully registered for',
      'You have cancelled participation in': 'You have cancelled participation in',
      RSVP: 'RSVP',
      'Waiting list': 'Waiting list',
      'Leave waiting list': 'Leave waiting list',
    },
    ru: {
      Withdraw: 'Отказаться',
      'Invitations only': 'Только по приглашениям',
      'You have successfully registered for': 'Вы успешно зарегистрировались на',
      'You have cancelled participation in': 'Вы отказались от участия в',
      RSVP: 'Регистрация',
      'Waiting list': 'Лист ожидания',
      'Leave waiting list': 'Покинуть лист ожидания',
    },
  },
})

const toast = useToastController()

const { $apiFetch } = useNuxtApp() as unknown as {
  $apiFetch: (path: string, opts?: Record<string, unknown>) => Promise<RegisterResponse>
}

async function register() {
  try {
    const data = await $apiFetch(
      `/${locale.value}/api/vip/events/${props.event.id}/register/`,
    )
    if (data.status === 'ok' && data.registration) {
      let action_type: string | null = null
      if (data.registration.type === 0) {
        action_type = 'rsvp'
      } else if (data.registration.type === 1) {
        action_type = 'waiting_list'
      }
      emit('reg_action', { response: data, action_type })

      const message = `${t('You have successfully registered for')} "${props.event.title}"`
      toast.create({
        props: {
          title: message,
          variant: 'success',
          value: 4000,
        },
      })
    } else if (data.status === 'err') {
      emit('reg_action', { response: data, action_type: null })
    }
  } catch (e) {
    console.error(e)
  }
}

async function unregister() {
  try {
    const data = await $apiFetch(
      `/${locale.value}/api/vip/events/${props.event.id}/unregister/`,
    )
    emit('reg_action', { response: data, action_type: 'unregister' })

    const message = `${t('You have cancelled participation in')} "${props.event.title}"`
    toast.create({
      props: {
        title: message,
        value: 4000,
      },
    })
  } catch (e) {
    console.error(e)
  }
}
</script>
